// GraphQL events
export const DASHBOARD_JOBS_FETCH = 'DASHBOARD_JOBS_FETCH';
export const DASHBOARD_JOBS_FETCH_SUCCESS = 'DASHBOARD_JOBS_FETCH_SUCCESS';
export const DASHBOARD_JOBS_FETCH_ERROR = 'DASHBOARD_JOBS_FETCH_ERROR';
export const JOB_EXPIRE = 'JOB_EXPIRE';
export const PAST_JOBS_FETCH_SUCCESS = 'PAST_JOBS_FETCH_SUCCESS';
export const DASHBOARD_INSIGHT_NOTIFICATIONS_FETCH_SUCCESS = 'DASHBOARD_INSIGHT_NOTIFICATIONS_FETCH_SUCCESS';
export const DASHBOARD_FEED_NOTIFICATIONS_FETCH_SUCCESS = 'DASHBOARD_FEED_NOTIFICATIONS_FETCH_SUCCESS';

// User actions
export const JOB_DISMISS_CLICK = 'JOB_DISMISS_CLICK';
export const NOTIFICATION_DISMISS_CLICK = 'NOTIFICATION_DISMISS_CLICK';
export const NOTIFICATION_ACTION_CLICK = 'NOTIFICATION_ACTION_CLICK';
